import React from 'react';

const WhySection = () => {
  // Benefits data
  const benefits = [
  {
    id: 1,
    title: 'Proven Migration Expertise',
    description: 'Extensive experience delivering successful cloud and infrastructure migration projects across various industries.',
    icon: 'check',
    delay: '200ms'
  },
  {
    id: 2,
    title: 'Secure Migration Process',
    description: 'Carefully planned migration strategies designed to minimize risk and ensure business continuity.',
    icon: 'shield',
    delay: '300ms'
  },
  {
    id: 3,
    title: 'End-to-End Services',
    description: 'From planning and migration to optimization and ongoing support, we manage the entire journey.',
    icon: 'users',
    delay: '400ms'
  },
  {
    id: 4,
    title: 'Infrastructure Specialists',
    description: 'Expertise in cloud platforms, virtualization, networking, and modern infrastructure technologies.',
    icon: 'grid',
    delay: '500ms'
  },
  {
    id: 5,
    title: 'Security & Compliance',
    description: 'Infrastructure solutions built with security, reliability, and compliance best practices in mind.',
    icon: 'globe',
    delay: '600ms'
  },
  {
    id: 6,
    title: 'Clear & Predictable Pricing',
    description: 'Transparent project estimates with no hidden fees and clear expectations from the start.',
    icon: 'chart',
    delay: '700ms'
  }
];

  // Icon components
const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-6 h-6 text-white">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0Z" />
  </svg>
);

const ShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-6 h-6 text-white">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M12 3l7.5 3v6c0 5.25-3.75 8.25-7.5 9-3.75-.75-7.5-3.75-7.5-9V6L12 3z" />
  </svg>
);

 const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-6 h-6 text-white">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zm-8 10a4 4 0 118 0H8z" />
  </svg>
);

const GridIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-6 h-6 text-white">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
  </svg>
);
const GlobeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-6 h-6 text-white">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25z" />
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M2.25 12h19.5M12 2.25c2.5 2.5 3.75 6.25 3.75 9.75S14.5 19.5 12 21.75M12 2.25C9.5 4.75 8.25 8.5 8.25 12S9.5 19.25 12 21.75" />
  </svg>
);

const ChartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
    strokeWidth="1.5" stroke="currentColor"
    className="w-6 h-6 text-white">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M3 17l5-5 4 4 8-8" />
  </svg>
);

  const getIcon = (iconType) => {
    switch (iconType) {
      case 'check':
        return <CheckIcon />;
      case 'shield':
        return <ShieldIcon />;
      case 'users':
        return <UsersIcon />;
      case 'grid':
        return <GridIcon />;
      case 'globe':
        return <GlobeIcon />;
      case 'chart':
        return <ChartIcon />;
      default:
        return <CheckIcon />;
    }
  };

  return (
    <section id="why-section" className="py-10 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 transition-all duration-1000 opacity-100 translate-y-0">
            Why Choose AyanshTech Solutions?
          </h2>
        </div>
        
        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div 
              key={benefit.id}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 opacity-100 translate-y-0"
              style={{ transitionDelay: benefit.delay, transitionDuration: '1000ms' }}
            >
              {/* Icon Box */}
              <div className="w-12 h-12 bg-gradient-to-br from-gray-500 to-gray-500 rounded-xl mb-4 flex items-center justify-center">
                {getIcon(benefit.icon)}
              </div>
              
              {/* Content */}
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-sm">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default WhySection;